import {IUserLocation} from '@/models/user.models';

export enum UserRole {
	Admin = 0,
	President = 5,
	ProjectManager = 10,
	ShopForeman = 15,
	VicePresident = 20
}

export class LoginModel {
	username: string = null;
	tokens: Object = null;
}

export interface IAuthUser {
	id: string;
	username: string;
	firstName: string;
	lastName: string;
	email: string;
	currentLocationId: string;
	locationName: string;
  role: UserRole;
	jobSource: string;
  locations: IUserLocation[];
}

export interface IAuthResult {
	user: IAuthUser;
	expires: string;
}
